// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_1F6IKqs7daL7EiF9N1d1LR","header":"_2CwH0KEhfsbtNFdYFXIcam","name":"_23XvBwN6bgim7MUFSStsIQ","time":"_32JbsJ1LtL2ecQhBBGSgLN","adminAction":"_18nKnTdzfuCNFttTRHGj9B","iconAction":"_3-jpQYVDX-lmVbe1FhWp4c","content":"_2CWCZagSgzXZx96cI4xrz8","children":"_1DNL8_FUHNl2sBYqF9C3Wr"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/Comment/style.css
// module id = 514
// module chunks = 38